  (function () {
    if (window.__pmRabattZeile) return;
    window.__pmRabattZeile = true;

    var geld = function (n) {
      return n.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    };
    var zahl = function (text) {
      if (!text) return null;
      var s = text.replace(/[^\d.,-]/g, '').replace(/\./g, '').replace(',', '.');
      var n = parseFloat(s);
      return isFinite(n) ? n : null;
    };

    var laeuft = false;
    var nachholen = false;
    var aktualisieren = function () {
      if (laeuft) { nachholen = true; return; }
      laeuft = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var voll = cart.total_price / 100;
          document.querySelectorAll('[data-pm-rabatt]').forEach(function (zeile) {
            var wurzel = zeile.closest('cart-drawer, #CartDrawer, .cart-drawer, form') || document;
            // Zuerst aus den Positionszeilen rechnen (BSS setzt die frueher als die Summe),
            // sonst auf das Summenfeld zurueckfallen.
            var zeilen = wurzel.querySelectorAll('[bss-b2b-final-line-price]');
            var rabattiert = null;
            if (zeilen.length) {
              var summe = 0;
              var vollstaendig = true;
              zeilen.forEach(function (el) {
                var wert = zahl(el.textContent);
                if (wert === null) vollstaendig = false;
                else summe += wert;
              });
              if (vollstaendig && summe > 0) rabattiert = summe;
            }
            if (rabattiert === null) {
              var summenFeld =
                wurzel.querySelector('[bss-b2b-cart-total-price]') ||
                document.querySelector('[bss-b2b-cart-total-price]');
              rabattiert = zahl(summenFeld && summenFeld.textContent);
            }
            // Plausibilitaet: solange BSS die Summe noch nicht gesetzt hat (0 oder leer), nichts zeigen.
            // Ein echter Mengenrabatt liegt bei uns hoechstens bei rund 10 Prozent.
            var diff = 0;
            if (rabattiert !== null && rabattiert > 0 && voll > 0) {
              var kandidat = voll - rabattiert;
              if (kandidat > 0.005 && kandidat < voll * 0.5) diff = kandidat;
            }
            var wertFeld = zeile.querySelector('[data-pm-rabatt-wert]');
            if (diff > 0.005) {
              var text = '-' + geld(diff);
              if (wertFeld.textContent !== text) wertFeld.textContent = text;
              if (zeile.hidden) zeile.hidden = false;
            } else if (!zeile.hidden) {
              zeile.hidden = true;
            }
          });
        })
        .catch(function () {})
        .then(function () {
          laeuft = false;
          if (nachholen) { nachholen = false; setTimeout(aktualisieren, 150); }
        });
    };


    // PRISMA: Warenkorbpreise schneller aktualisieren (Empfehlung BSS-Support, 24.09.2026).
    // Ausgangslage: Nach jeder Mengenaenderung dauerte es rund 2,3 Sekunden, bis der rabattierte
    // Positionspreis stimmte. Grund ist nicht die Rabattrechnung selbst (die laeuft lokal in
    // Millisekunden), sondern dass die App nach der Aenderung wartet und wiederholt /cart.js abfragt,
    // bis Shopify den Warenkorb fertig aktualisiert hat.
    // Unser Theme kennt die neue Warenkorbantwort aber sofort: cart.js ruft routes.cart_change_url
    // per fetch auf und bekommt den kompletten Warenkorb zurueck. Wir fangen diese Antwort ab und
    // reichen sie per Ereignis direkt an die App weiter, dann faellt die Warterei weg.
    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function (eingabe, optionen) {
        var url = '';
        try {
          url = typeof eingabe === 'string' ? eingabe : (eingabe && eingabe.url) || '';
        } catch (e) {}
        var istWarenkorbAenderung =
          url.indexOf('/cart/change') >= 0 || url.indexOf('/cart/update') >= 0;
        var antwort = originalFetch.apply(this, arguments);
        if (!istWarenkorbAenderung) return antwort;
        return antwort.then(function (res) {
          try {
            res
              .clone()
              .json()
              .then(function (cart) {
                // Die Antwort enthaelt den ganzen Warenkorb (plus die vom Theme angeforderten
                // Abschnitte). Nur weiterreichen, wenn es wirklich ein Warenkorb ist.
                if (cart && typeof cart.item_count === 'number') {
                  // Wichtig: Die App horcht auf document, nicht auf window (geprueft in
                  // bss-b2b-v3.js: document.addEventListener('bss_b2b:CustomCartUpdate', ...)).
                  // Auf window ausgeloeste Ereignisse erreichen document nicht.
                  //
                  // Mehrfach melden: Das Theme ersetzt nach derselben Antwort die Warenkorb-
                  // Abschnitte komplett. Meldet man nur sofort, schreibt die App den richtigen
                  // Preis in Elemente, die gleich danach weggeworfen werden. Die spaeteren
                  // Meldungen landen nach dem Neuaufbau. Die Rabattrechnung selbst laeuft lokal
                  // in Millisekunden, das kostet also praktisch nichts.
                  var melden = function () {
                    document.dispatchEvent(
                      new CustomEvent('bss_b2b:CustomCartUpdate', { detail: { cart: cart } })
                    );
                  };
                  melden();
                  [80, 200, 400, 700].forEach(function (ms) { setTimeout(melden, ms); });
                }
              })
              .catch(function () {});
          } catch (e) {}
          return res;
        });
      };
    }

    // PRISMA: Mindestbestellmenge. Die Menge steht als data-pm-min an der Warenkorbzeile
    // (snippets/cart-item.liquid, Quelle: Metafeld custom.mindestbestellmenge aus weclapp).
    // Gezaehlt wird pro Produkt ueber alle Positionen, weil derselbe Artikel in mehreren
    // Konfigurationen im Warenkorb liegen kann. Warenkorbseite und Mini-Warenkorb zeigen dieselbe
    // Position, deshalb wird ueber die id der Zeile entdoppelt.
    var mindestmengeFehlt = function () {
      var zeilen = {};
      document.querySelectorAll('[data-pm-min]').forEach(function (zeile) {
        var min = parseInt(zeile.getAttribute('data-pm-min'), 10);
        if (!min || min < 2) return;
        var feld = zeile.querySelector('.js-counter-quantity, input[name="updates[]"]');
        var menge = feld ? parseInt(feld.value, 10) : NaN;
        if (!isFinite(menge) || menge < 1) return;
        zeilen[zeile.id || Math.random()] = {
          titel: zeile.getAttribute('data-pm-titel') || 'Dieser Artikel',
          min: min,
          menge: menge,
        };
      });
      var proProdukt = {};
      Object.keys(zeilen).forEach(function (id) {
        var z = zeilen[id];
        if (!proProdukt[z.titel]) proProdukt[z.titel] = { titel: z.titel, min: z.min, menge: 0 };
        proProdukt[z.titel].menge += z.menge;
      });
      return Object.keys(proProdukt)
        .map(function (t) { return proProdukt[t]; })
        .filter(function (e) { return e.menge < e.min; });
    };

    var hinweisText = function (offen) {
      if (!offen.length) return '';
      var teile = offen.map(function (e) { return e.titel + ' ab ' + e.min + ' Stück'; });
      return 'Mindestbestellmenge noch nicht erreicht: ' + teile.join(', ') + '.';
    };

    var hinweisSetzen = function (button, text) {
      var eltern = button.parentNode;
      if (!eltern) return;
      var el = eltern.querySelector('[data-pm-mindest-hinweis]');
      if (!text) { if (el) el.hidden = true; return; }
      if (!el) {
        el = document.createElement('div');
        el.setAttribute('data-pm-mindest-hinweis', '');
        el.className = 'pm-mindest-hinweis';
        eltern.insertBefore(el, button);
      }
      if (el.textContent !== text) el.textContent = text;
      el.hidden = false;
    };

    // Gesperrt wird ueber eine Klasse mit !important, nicht ueber den Inline-Style: BSS setzt am
    // Kasse-Button selbst "pointer-events: unset" und wuerde einen Inline-Style ueberschreiben.
    var anwenden = function (button, gesperrt) {
      var istGesperrt = button.dataset.pmGesperrt === '1';
      if (gesperrt) {
        // Nicht nur beim Wechsel setzen: das Theme aktiviert die Knoepfe nach jedem
        // Warenkorb-Update wieder, deshalb bei jedem Takt nachziehen.
        button.dataset.pmGesperrt = '1';
        button.classList.add('pm-kasse-gesperrt');
        button.setAttribute('aria-disabled', 'true');
        if (button.tagName === 'BUTTON' && !button.disabled) button.disabled = true;
      } else if (istGesperrt) {
        delete button.dataset.pmGesperrt;
        button.classList.remove('pm-kasse-gesperrt');
        button.removeAttribute('aria-disabled');
        if (button.tagName === 'BUTTON') button.disabled = false;
      }
    };

    // Letzte Absicherung: Klick abfangen, falls eine App die Sperre doch aushebelt.
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[name="checkout"], a[href^="/checkout"]');
      if (!button) return;
      if (!mindestmengeFehlt().length) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    // Kasse-Button absichern. Zwei Gruende zu sperren:
    // 1. Mindestbestellmenge noch nicht erreicht (dauerhaft, bis der Kunde die Menge erhoeht).
    // 2. BSS haengt sich erst ein bis zwei Sekunden nach dem Rendern an den Button und setzt den
    //    Rabatt erst beim Klick. Simulierte Klicks ignoriert BSS, deshalb warten wir auf die
    //    Markierung bss-b2b-cart-trigger-added, hoechstens acht Sekunden.
    var sperren = function () {
      var offen = mindestmengeFehlt();
      var text = hinweisText(offen);
      document.querySelectorAll('[name="checkout"], a[href^="/checkout"]').forEach(function (button) {
        hinweisSetzen(button, text);
        if (offen.length) { anwenden(button, true); return; }
        if (!button.dataset.pmSeit) button.dataset.pmSeit = String(Date.now());
        var bereit = button.getAttribute('bss-b2b-cart-trigger-added') === 'true';
        var abgelaufen = Date.now() - parseInt(button.dataset.pmSeit, 10) > 8000;
        anwenden(button, !(bereit || abgelaufen));
      });
    };

    var timer = null;
    var angestossen = function () {
      clearTimeout(timer);
      timer = setTimeout(function () { aktualisieren(); sperren(); }, 120);
    };

    angestossen();
    document.addEventListener('DOMContentLoaded', angestossen);
    // BSS rechnet die Summen verzoegert; deshalb ein paar Nachkontrollen.
    [250, 500, 800, 1200, 1800, 2500, 3500, 5000].forEach(function (ms) { setTimeout(angestossen, ms); });
    // BSS rechnet die Summe nach dem Laden und nach jeder Mengenaenderung neu.
    // Der Zustand haengt auch an einem Attribut (bss-b2b-cart-trigger-added) und an Tippen im
    // Mengenfeld, das der Beobachter unten nicht sieht, deshalb zusaetzlich ein kurzer Takt.
    setInterval(sperren, 200);
    new MutationObserver(angestossen).observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
    });
  })();
